import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectBox from '../select-box/SelectBox';
import ImageInput from '../image-input/ImageInput';
import VideoInput from '../video-input/VideoInput';
import './FeaturedMediaInput.css';

export default class FeaturedMediaInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mediaType: (this.props.existingContentObject) ? this.props.existingContentObject.mediaType : undefined
    };
    
    this.mediaTypeOptions = [
      {
        name: "None",
        value: ""
      },
      {
        name: "Image",
        value: "image"
      },
      {
        name: "Video",
        value: "video"
      }
    ];
  }

  // Grabs all of the input values in an object
  getValue = () => {
    let valuesObject = (this.state.mediaType) ? this[this.props.id + '-format-input'].getValue() : {};
    
    for (let propName in valuesObject) {
      if (valuesObject[propName] === "" || valuesObject[propName] === null) {
        delete valuesObject[propName];
      }
    }
    
    valuesObject.mediaType = this.state.mediaType;

    return valuesObject;
  }

  // Updates the type of the chart while preserving the current inputs in a temp object
  updateMediaType = (newType) => {
    this.setState({ mediaType : newType });
  }

  render () {
    let label = (this.props.label) ?
      <label htmlFor={this.props.id}>
        {this.props.label}
      </label> :
      null;

    let errorMessage = (this.props.errorMessage) ?
      <span className="error-message">
        {this.props.errorMessage}
      </span> :
      null;

    let verticalSpacingClass = this.props.verticalSpacing === "compact" ? "field--compact" : "field";
    
    let input = null;
    
    if (this.state.mediaType) {
      input = (this.state.mediaType === "image") ?
        <ImageInput 
          id={this.props.id + "__format-input"}
          isEditable={this.props.isEditable}
          existingContentObject={this.props.existingContentObject}
          ref={instance => { this[this.props.id + '-format-input'] = instance; }}
        /> :
        <VideoInput
          id={this.props.id + "__format-input"}
          isEditable={this.props.isEditable}
          existingContentObject={this.props.existingContentObject}
          ref={instance => { this[this.props.id + '-format-input'] = instance; }}
        />;
    }

    let inputDisplay = (this.props.isEditable) ?
      <span>
        {label}
        <SelectBox
          existingContent={this.state.mediaType}
          id={this.props.id + '-media-type'}
          onChange={this.updateMediaType}
          options={this.mediaTypeOptions}
          ref={instance => { this[this.props.id + '-media-type'] = instance; }}
        />
        {input}
        {errorMessage}
      </span> :
      <span>
        {label}
        <div className="read-only">
          {input}
        </div>
      </span>;

    return (
      <div className={"featured-media-input " + verticalSpacingClass + " " + this.props.className}>
        {inputDisplay}
      </div>
    );
  }
}

FeaturedMediaInput.defaultProps = {
  isEditable: true
};

FeaturedMediaInput.propTypes = {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  existingContentObject: PropTypes.shape({
    mediaType: PropTypes.string,
    imageAlt: PropTypes.string,
    imageCaption: PropTypes.string,
    imageURL: PropTypes.string,
    videoId: PropTypes.string,
    caption: PropTypes.string,
    type: PropTypes.string
  }),
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  verticalSpacing: PropTypes.string
}